module.exports = __webpack_public_path__ + "static/media/montserrat-regular.f9202a99.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/montserrat-regular.otf
// module id = 534
// module chunks = 0